import { uuid } from "expo-modules-core";
import { observer } from "mobx-react-lite";
import React from "react";
import { Text, XStack } from "tamagui";
import type { SortableItemWithId } from "../../../../core/components/SortableList";
import { BodyTextarea } from "../../../../ui/Body";
import { Box } from "../../../../ui/Box";
import { Label } from "../../../../ui/Label";
import { PopoverConfirm } from "../../../../ui/PopoverConfirm";
import type { BusinessPlanModel, BusinessTag } from "../../BusinessPlanModel";
import { BusinessSortableList } from "../../ui/BusinessSortableList";

export const BusinessPlanSettingsTags = observer(
  ({ businessPlan }: { businessPlan: BusinessPlanModel }) => {
    const renderItem = React.useCallback(
      (item: SortableItemWithId<BusinessTag>) => {
        const tag = item.item;

        return (
          <XStack gap={"$medium"}>
            <BodyTextarea value={tag.name} />
            <PopoverConfirm
              placement="top-start"
              onConfirm={() => {
                businessPlan.deleteTag(tag);
              }}
            >
              <Text cursor="pointer">Delete</Text>
            </PopoverConfirm>
          </XStack>
        );
      },
      [businessPlan],
    );

    const onSort = React.useCallback(
      (items: BusinessTag[]) => {
        businessPlan.updateTagsOrder(items);
      },
      [businessPlan],
    );

    const onAdd = React.useCallback(
      (tagTitle: string) => {
        if (tagTitle) {
          businessPlan.addTag({
            uid: uuid.v4(),
            name: tagTitle,
            isDeleted: false,
          });
        }
      },
      [businessPlan],
    );

    return (
      <Box>
        <Label>Tags</Label>
        <BusinessSortableList<BusinessTag>
          itemDescription={"Tag"}
          items={businessPlan.data.eventInfo.tags}
          renderItem={renderItem}
          onSort={onSort}
          onAdd={onAdd}
        />
      </Box>
    );
  },
);
